<template>
  <GcMenu
    v-model="menuOpen"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
    attach
  >
    <template #activator="{ on, attrs }">
      <gc-text-field
        :value="value"
        prepend-icon="$vuetify.icon.calendarRange"
        readonly
        clearable
        v-bind="attrs"
        :rules="rules"
        v-on="on"
        @click:clear="onClear()"
      ></gc-text-field>
    </template>
    <v-date-picker
      :range="range"
      :value="computedDatepickerValue"
      :first-day-of-week="1"
      :min="minValue"
      :max="maxValue"
      :allowed-dates="allowedDates"
      no-title
      @input="onInput"
    ></v-date-picker>
  </GcMenu>
</template>

<script lang="ts">
import { PropType, computed, ref } from '@vue/composition-api';
import { VDatePicker, VInput } from 'vuetify/lib';
import {
  formatDate,
  formatDateRange,
  parseDate,
  parseDates,
} from '@/lib/formatter/dates';
import GcMenu from '@/components/primitives/GcMenu.vue';
import GcTextField from '@/components/primitives/GcTextField.vue';
import { AssistantContext } from '~/steps/steps';

export default VInput.extend({
  components: {
    GcMenu,
    GcTextField,
    VDatePicker,
  },
  props: {
    assistantContext: {
      default: () => ({}),
      type: Object as PropType<AssistantContext>,
    },
    max: {
      type: [String, Function],
    },
    min: {
      type: [String, Function],
    },
    range: {
      type: Boolean,
    },
    allowedDates: {
      type: Function,
      default: () => true,
    },
  },
  setup: (props, { emit }) => {
    const menuOpen = ref(false);

    const onInput = (value: Array<string> | string) => {
      emit(
        'input',
        Array.isArray(value) ? formatDateRange(value) : formatDate(value),
      );
    };

    const onClear = () => {
      emit('input', '');
    };

    const computedDatepickerValue = computed(() =>
      props.range
        ? parseDates((props.value as string) || '', true)
        : parseDate((props.value as string) || ''),
    );

    const minValue = computed(() =>
      typeof props.min === 'function'
        ? props.min(props.assistantContext)
        : props.min,
    );

    const maxValue = computed(() =>
      typeof props.max === 'function'
        ? props.max(props.assistantContext)
        : props.max,
    );

    return {
      computedDatepickerValue,
      maxValue,
      menuOpen,
      minValue,
      onClear,
      onInput,
    };
  },
});
</script>
